import { EdgeLoadEventLabelRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadEventLabel } from '@/shared/domain/use-cases'

export function makeLoadEventLabel(): LoadEventLabel {
  return new EdgeLoadEventLabelRepository(makeSupabaseEdgeHttpClient()).execute
}
